<template>
  <div>
    <page-header :header="`${type} Article`">
      <button v-if="id" @click="showDeleteModal = true" class="bg-white rounded-lg p-4 uppercase text-sm font-medium align-bottom mr-4">
        <i class="far fa-trash-alt fa-fw fa-lg" />
        Delete Article
      </button>
      <button @click="save" class="bg-secondary text-primary rounded-lg p-4 uppercase text-sm font-medium align-bottom">
        <i class="far fa-save fa-fw fa-lg" />
        Save Article
      </button>
    </page-header>

    <deletion-modal
      v-if="showDeleteModal"
      @confirmed="destroy"
      @leave="showDeleteModal = false"
      @dismissed="showDeleteModal = false"
    >
      <p>Deleting an article is permenant, are you sure?</p>
    </deletion-modal>
    <div class="w-full">
     <div class="flex flex-col" v-if="system.networks && system.networks.length > 1">
        <p class="w-full mb-2">Article Visibility by Network:</p>
        <div class="xl:flex-row md:flex md:flex-row sm:flex-col space-between w-1/2">
          <div v-for="(network, i) in system.networks" :key="i" class="text-sm uppercase">
            <input type="radio"  :id="+i" name="network.id" :value="network.id" v-model="article.assigned_network">
            <label :for="+i" class="ml-4 mt-2">{{ network.name }}</label>
          </div>
          <input type="radio" id="all" name="network.id" :value="null" v-model="article.assigned_network">
          <label for="all"  class="ml-4 mt-2">ALL</label>
        </div>
        <div v-if="country_list && [7, 8].includes(selectedOffice.network_id) && system.networks.length > 1" class="w-1/2">
          <div class="flex mt-6 -mb-4">
            <p class="w-full">Article visible to (Country):</p>
            <checkbox-input label="Select all" @input="toggleSelectAllCountries" :value="true" />
          </div>
          <select-input
            v-model="article.assigned_countries"
            :options="country_list"
          />
          <div class="flex -mt-3" v-show="country_list.length>0">
            <div class="w-full text-right text-sm text-gray-600">
              {{ article.assigned_countries.length }} selected
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="article" class="flex w-full mt-6">
      <div class="flex-grow bg-white rounded-lg p-6 pt-0 mt-12">
        <div class="flex flex-wrap items-center border-b mb-6 pb-2">
          <div class="bg-tertiary text-white p-4 w-32 h-32 -mt-12 mb-2 rounded-lg relative">
            <icon name="news" :center="false" />
          </div>
          <input type="text" placeholder="Title" class="input w-2/3 mr-4 sm:mx-6" v-model="article.title">
          <button type="button" class="rounded-full h-10 w-10 flex justify-center items-center border" @click="mediaManagerVisible = true">
            <i class="fas fa-link fa-lg" />
          </button>
        </div>

        <tinymce
          :init="editorConfig"
          v-model="article.content"
        />
      </div>

      <modal
        height="90vh"
        width="70vw"
        v-if="mediaManagerVisible"
      >
        <media-manager
          @selected="selectMedia($event)"
          @closeMediaManager="mediaManagerVisible = false"
        />
      </modal>
    </div>

    <loader v-else />
  </div>
</template>

<script>
import DeletionModal from '@/components/Modals/DeletionModal'
import { mapState, mapActions, mapMutations } from 'vuex'
import { find } from 'lodash'
import api from '@/http'
import ErrorBag from '@/ErrorBag'
import mceConfig from '@/mixins/TinyMCE'

export default {
  mixins: [ mceConfig ],

  components: { DeletionModal },

  props: ['id'],

  data () {
    return {
      showDeleteModal: false,
      mediaManagerVisible: false,
      isSaving: false,
      isConfirmingDelete: false,
      isDeleting: false,
      errorBag: new ErrorBag(),
      article: {
        title: null,
        intro: null,
        content: null,
        website_url: null,
        assigned_network: null,
        assigned_countries: []
      },
      country_list: [
        { 'id': 'GB', 'name': 'UK' },
        { 'id': 'UKA', 'name': 'UK Associate' },
        { 'id': 'AU', 'name': 'Australia' },
        { 'id': 'BB', 'name': 'Barbados' },
        { 'id': 'BG', 'name': 'Bulgaria' },
        { 'id': 'CY', 'name': 'Cyprus' },
        { 'id': 'EE', 'name': 'Estonia' },
        { 'id': 'FI', 'name': 'Finland' },
        { 'id': 'FR', 'name': 'France' },
        { 'id': 'DE', 'name': 'Germany' },
        { 'id': 'GR', 'name': 'Greece' },
        { 'id': 'HU', 'name': 'Hungary' },
        { 'id': 'IE', 'name': 'Ireland' },
        { 'id': 'IT', 'name': 'Italy' },
        { 'id': 'JE', 'name': 'Jersey' },
        { 'id': 'MU', 'name': 'Mauritius' },
        { 'id': 'NA', 'name': 'Namibia' },
        { 'id': 'PT', 'name': 'Portugal' },
        { 'id': 'ES', 'name': 'Spain' },
        { 'id': 'ZA', 'name': 'South Africa' },
        { 'id': 'CH', 'name': 'Switzerland' },
        { 'id': 'TH', 'name': 'Thailand' },
        { 'id': 'AE', 'name': 'UAE' },
        { 'id': 'ZW', 'name': 'Zimbabwe' }
      ]
    }
  },

  computed: {
    ...mapState([
      'articles', 'system', 'selectedOffice'
    ]),

    type () {
      return this.id ? 'Edit' : 'Create New'
    }
  },

  methods: {
    ...mapActions([
      'displayToastNotification'
    ]),

    ...mapMutations([
      'setArticle'
    ]),

    selectMedia (media) {
      this.mediaManagerVisible = false
      this.article.website_url = media.path
    },

    load () {
      if (this.id) {
        this.article = find(this.articles, a => a.slug === this.id)
      }
    },

    destroy () {
      this.showDeleteModal = false
      this.isDeleting = true

      api
        .delete(`news/${this.id}`)
        .then(response => {
          this.isDeleting = false
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Article Deleted',
            info: `Article "${this.article.title}" has been successfully deleted.`
          })
          this.$router.push('/admin')
        })
        .catch(error => {
          this.isDeleting = false
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-exclamation',
            title: 'Unable to delete article',
            info: error.response.data.message
          })
        })
    },

    save () {
      this.isSaving = true
      this.errorBag.clear()

      if (this.id) {
        this.update()
      } else {
        this.create()
      }
    },

    update () {
      api
        .patch(`news/${this.id}`, this.article)
        .then(response => this.onSaveSuccess(response))
        .catch(error => this.onSaveError(error.response))
    },

    create () {
      api
        .post('news', this.article)
        .then(response => this.onSaveSuccess(response))
        .catch(error => this.onSaveError(error.response))
    },

    onSaveSuccess (response) {
      this.isSaving = false
      this.article = response.data
      this.setArticle(response.data)
      this.displayToastNotification({
        type: 'success',
        icon: 'fa-check',
        title: 'Article Saved',
        info: `Article "${this.article.title}" has been successfully saved.`
      })
      this.$router.push(`/admin`)
    },

    onSaveError (response) {
      this.isSaving = false
      this.errorBag.store(response.data)
      this.displayToastNotification({
        type: 'warning',
        icon: 'fa-bell',
        title: 'Unable to save article',
        info: response.data.message
      })
    },
    toggleSelectAllCountries (flag) {
      if (flag) {
        this.article.assigned_countries = []
        for (var index in this.country_list) {
          this.article.assigned_countries.push(this.country_list[index].id)
        }
      } else {
        this.article.assigned_countries = []
      }
    }
  },

  created () {
    this.load()
    if (!this.id) {
      this.toggleSelectAllCountries(true)
    }
  },

  watch: {
    articles () {
      this.load()
    },
    'article.assigned_network': {
      handler () {
        this.country_list = [
          { 'id': 'GB', 'name': 'UK' },
          { 'id': 'UKA', 'name': 'UK Associate' },
          { 'id': 'AU', 'name': 'Australia' },
          { 'id': 'BB', 'name': 'Barbados' },
          { 'id': 'BG', 'name': 'Bulgaria' },
          { 'id': 'CY', 'name': 'Cyprus' },
          { 'id': 'EE', 'name': 'Estonia' },
          { 'id': 'FI', 'name': 'Finland' },
          { 'id': 'FR', 'name': 'France' },
          { 'id': 'DE', 'name': 'Germany' },
          { 'id': 'GR', 'name': 'Greece' },
          { 'id': 'HU', 'name': 'Hungary' },
          { 'id': 'IE', 'name': 'Ireland' },
          { 'id': 'IT', 'name': 'Italy' },
          { 'id': 'JE', 'name': 'Jersey' },
          { 'id': 'MU', 'name': 'Mauritius' },
          { 'id': 'NA', 'name': 'Namibia' },
          { 'id': 'PT', 'name': 'Portugal' },
          { 'id': 'ES', 'name': 'Spain' },
          { 'id': 'ZA', 'name': 'South Africa' },
          { 'id': 'CH', 'name': 'Switzerland' },
          { 'id': 'TH', 'name': 'Thailand' },
          { 'id': 'AE', 'name': 'UAE' },
          { 'id': 'ZW', 'name': 'Zimbabwe' }
        ]
        if (this.article.assigned_network === 7) {
          this.country_list = this.country_list.splice(0, 2)
        } else if (this.article.assigned_network === 8) {
          this.country_list = this.country_list.splice(2, this.country_list.length)
        }
        this.toggleSelectAllCountries(true)
      }
    }
  }
}
</script>
